/**
 * useClubName
 */

import { useConfig } from '../../contexts/config';

const useClubName = () => {

    const { clubName } = useConfig();

    return clubName;

};

export default useClubName;
